import { FpjsProvider as c, useVisitorData as p } from "@fingerprintjs/fingerprintjs-pro-react";
import { useConfigContext as d } from "../config/ConfigContext.js";
import l from "../../hooks/graphql/useBindFingerprint.js";
import { createStrictContext as f } from "../../util/context/createStrictContext.js";
import * as m from "ramda";
import * as u from "ramda-adjunct";
import { useCallback as P } from "react";
import { jsx as n, Fragment as g } from "react/jsx-runtime";
const [F, j] = f("FingerPrint", {
  bindFingerPrint: () => {
  }
}), x = (o) => {
  const {
    children: i
  } = o, {
    getData: t
  } = p({
    extendedResult: !0
  }, {
    immediate: !1
  }), {
    mutate: r
  } = l(), e = P(async () => {
    const {
      visitorId: s,
      requestId: a
    } = await t();
    !m.isNil(s) && !m.isNil(a) && r({
      visitorId: s,
      requestId: a
    });
  }, [t, r]);
  return /* @__PURE__ */ n(F, {
    value: {
      bindFingerPrint: e
    },
    children: i
  });
}, R = (o) => {
  var e;
  const {
    children: i
  } = o, {
    config: t
  } = d(), r = ((e = t == null ? void 0 : t.fingerPrint) == null ? void 0 : e.key) || "";
  return u.isNotNilOrEmpty(r) ? /* @__PURE__ */ n(c, {
    loadOptions: {
      apiKey: r,
      scriptUrlPattern: "/script/fingerprint.raw.js"
    },
    children: /* @__PURE__ */ n(x, {
      children: i
    })
  }) : /* @__PURE__ */ n(g, {
    children: i
  });
};
export {
  R as FingerPrintProvider,
  j as useFingerPrintContext
};
//# sourceMappingURL=FingerprintContext.js.map
